const CompanyStateEnum = Object.freeze({
    PREPARING: { value: 'preparing', text: 'Preparing' },
    PROVIDING: { value: 'providing', text: 'Providing' },
    STOPPED_TEMPORARILY: { value: 'stopped_temporarily', text: 'Stopped temporarily' },
    END: { value: 'end', text: 'End' },
});

export default CompanyStateEnum;
